import { Sidebar } from "./Sidebar";
import type { DesktopSidebarProps } from "../../types";

export function DesktopSidebar({ collapsed }: DesktopSidebarProps) {
  return (
    <div
      className={`hidden lg:block transition-all duration-300 ${
        collapsed ? "w-[50px]" : "w-[200px]"
      }`}
    >
      <Sidebar />
    </div>
  );
}
